module.exports = __webpack_public_path__ + "static/media/map.bbec67a1.png";